// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectTypeOfTitleQueryResult, selectTypeOfTitlesPageLoading, selectTypeOfTitlesShowInitWaitingMessage} from '../_selectors/type-of-title.selectors';

export class TypeOfTitlesDataSource extends BaseDataSource {
    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectTypeOfTitlesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectTypeOfTitlesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectTypeOfTitleQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
